import { NgClass, NgIf } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TooltipOnTruncateDirective } from '../../../../../../shared/directives/tooltip-on-truncate.directive';
import { Entities } from '../../../../../data-rules-model';
import { IEntityItem } from '../../../paired-autocomplete.component';

@Component({
  selector: 'app-entity-item',
  templateUrl: './entity-item.component.html',
  styleUrls: ['./entity-item.component.scss'],
  imports: [
    NgClass,
    NgIf,
    TooltipOnTruncateDirective
  ]
})
export class EntityItemComponent {
  @Input() entity: IEntityItem;
  @Input() primaryEntity: Entities;
  @Input() descriptorControl: FormControl;
  @Input() entitySelectorsMap: IEntityItem[];
  @Input() isSelected: (entity: IEntityItem) => boolean;
  @Input() renderIcon: (entity: string) => string;

  isDescriptionShown = false;

  @HostListener('mouseenter')
  onMouseEnter() {
    this.isDescriptionShown = true;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.isDescriptionShown = false;
  }

  getEntityLabelSelector(actualEntity: IEntityItem, isDescriptionShown: boolean): string {
    return (!!actualEntity.secondaryDescriptor
        ? (isDescriptionShown ? 'with-description' : 'without-description')
        : 'without-description'
    );
  }

  getEntityDescriptionSelector(isDescriptionShown: boolean): string {
    return ('entity-description' + ' ' + (isDescriptionShown ? 'visible' : 'not-visible'));
  }

  getSelectorFromEntityLabel(label: string): string {
    return label.split(' ').map(str => str.toLowerCase()).join('-');
  }

  selectEntity(descriptor: string | null): void {
    if (descriptor !== this.descriptorControl.value) {
      this.descriptorControl.setValue(descriptor);
    }
  }

  getEntityValue(entity: IEntityItem) {
    return this.entitySelectorsMap[entity.value];
  }

}
